// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveProgramDeactivationChangeRequestStep1Handler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ProgramDeactivationChangeRequestDTO from '../models/ProgramDeactivationChangeRequestDTO';
import ChangeRequestDTO from '../models/ChangeRequestDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    changeRequestId: string | null | null;
    institutionId: string | null;
    programDeactivationChangeRequest: ProgramDeactivationChangeRequestDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            changeRequestId: null,
            institutionId: '00000000-0000-0000-0000-000000000000',
            programDeactivationChangeRequest: null,
        },
        initValues);
    },
    changeRequestId: 'changeRequestId',
    institutionId: 'institutionId',
    programDeactivationChangeRequest: 'programDeactivationChangeRequest',
}

interface Result extends ResultDTO {
    changeRequest: ChangeRequestDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            changeRequest: null,
        },
        initValues);
    },
    changeRequest: 'changeRequest',
}

export { Request, Result };